import React, { useEffect, useMemo, useState } from "react";
import { Box, Typography, Button, Grid, CardMedia } from "@mui/material";
// import { useWeb3Context } from "../context/UseWeb3Context";
import { ethers } from "ethers";
import drop from "../assets/images/drop.jpeg";
// import about2 from "../assets/images/about2.png";
import BigBeyondABI from "../utils/BigBeyondABI.json";
// import { useAuthContext } from "../context/AuthContextProvider";

import QRcode from "qrcode";
import { ContentContainer } from "../layout/ContentContainer";

const NFTVerification = () => {
  const tokenId = new URLSearchParams(window.location.search).get("tokenId");
  const [tokenData, setTokenData] = useState("");
  const [contractName, setContractName] = useState("");
  // const { account, library } = useWeb3Context();
  // const { bigBeyondContract } = useAuthContext();
  // const contract = useMemo(
  //   () => bigBeyondContract(library, account),
  //   [bigBeyondContract, library, account]
  // );

  const RPC = process.env.REACT_APP_RPC_URL;
  const provider = new ethers.providers.JsonRpcProvider(RPC, { chainId: 4 });

  const contract = new ethers.Contract(
    process.env.REACT_APP_CONTRACT_ADDRESS,
    BigBeyondABI,
    provider
  );

  const createQrCode = () => {
    const data = `${process.env.REACT_APP_DOMAIN}/verify-nft?tokenId=${tokenId}`;
    const canvas = document.querySelector("#canvas");
    QRcode.toCanvas(canvas, data, (err) => {
      // err && console.log(err);
    });
  };

  useEffect(() => {
    createQrCode();
  }, []);

  useEffect(() => {
    const getData = async () => {
      const ownData = await contract.ownerOf(tokenId);
      const name = await contract.name().then((res) => {
        return res;
      });
      setContractName(name);
      setTokenData(ownData);
    };
    contract && getData();
  }, [contract]);

  return (
    <ContentContainer>
      <Box
        sx={{
          width: "100%",
          position: "relative",
          textAlign: "center",
          paddingTop: "25px",
          paddingBottom: "25px",
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          authenticated
          <Typography> This NFT was minted at Big Beyond.</Typography>
        </Typography>
      </Box>

      <Grid container sx={{ height: { md: "512px", xs: "273px" } }}>
        <Grid item md={12} xs={12} backgroundColor="black" align="center">
          <CardMedia
            component="img"
            src={drop}
            alt="couldn't load image"
            sx={{
              height: { md: "512px", xs: "273px" },
              width: "66%",
            }}
          />
        </Grid>
      </Grid>

      <Box
        sx={{
          position: "relative",
          textAlign: "center",
          // width: "769px",
          width: { md: "769px", xs: "97%" },
          marginLeft: "auto",
          marginRight: "auto",
          boxShadow: "2",
        }}
      >
        <Typography variant="h4" marginTop="15px">
          {contractName}
        </Typography>
        {tokenData && <Typography> Owned by: {tokenData} </Typography>}
        <Typography> ERC721 ID: {tokenId}</Typography>
        <Typography>
          Description : A young Ukrainian girl defiantly painting a new future
          because self-belief is the best middle finger to oppression.
        </Typography>
        <Button sx={{ margin: "15px 0px 23px 0px" }} variant="contained">
          <a
            style={{ textDecoration: "none", color: "black" }}
            target="_opensea"
            href={`https://opensea.io/assets/ethereum//${process.env.REACT_APP_CONTRACT_ADDRESS}/${tokenId}`}
          >
            show on opensea
          </a>
        </Button>
        <Box
          sx={{
            position: "relative",
            textAlign: "center",
            display: "block",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        ></Box>
      </Box>
      <Box
        style={{
          // width: "769px",
          width: { md: "769px", xs: "97%" },

          textAlign: "center",
        }}
      >
        <canvas id="canvas"></canvas>
      </Box>
    </ContentContainer>
  );
};

export default NFTVerification;
